import { h, F as Fragment } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';

const labelId = 'label';
const descriptionId = 'description';
/**
 * Accessible label component that can be used to display a label and help text for form fields.
 * Remember to add `@import 'path/to/label.scss';` to the component's SCSS file so the styles are applied.
 */
const Label = ({ label, labelFontStyle, helptext, htmlFor, required, disabled, dark, type: Element = 'label', noMargin, }) => {
    if (!label && !helptext) {
        return null;
    }
    return (h("div", { class: classNames('label-wrapper', dark && 'dark', noMargin && 'noMargin') },
        h(Element, { class: classNames('label', `fontStyle--${labelFontStyle}`), id: labelId, "aria-disabled": String(disabled), htmlFor: htmlFor }, label && (h(Fragment, null,
            label,
            required && (h("span", { class: 'required', "aria-hidden": 'true' },
                ' ',
                "*"))))),
        helptext && (h("span", { class: 'label', id: descriptionId, "aria-disabled": String(disabled) }, helptext))));
};

export { Label as L, descriptionId as d, labelId as l };
